import ChunkBase from './ChunkBase';
import TrapSpikes from './traps/jungle/TrapSpikes';
import TrapCoconuts from './traps/jungle/TrapCoconuts';
import TrapTorch from './traps/cave/TrapTorch';
import { TrapAnimatedTorch } from './traps/cave/TrapAnimatedTorch';

export class TrapFactory {
  protected scene: Phaser.Scene;
  protected isInitialised: boolean;
  protected trapSpikeGroup!: Phaser.GameObjects.Group;
  protected trapCoconutGroup!: Phaser.GameObjects.Group;
  protected trapTorchGroup!: Phaser.GameObjects.Group;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
    this.isInitialised = false;
  }

  public init() {
    // if (this.isInitialised) return;

    this.trapSpikeGroup = this.scene.add.group([], {
      classType: TrapSpikes
    });

    this.trapCoconutGroup = this.scene.add.group([], {
      classType: TrapCoconuts
    });

    this.trapTorchGroup = this.scene.add.group([], {
      classType: TrapAnimatedTorch
    });

    // this.isInitialised = true;
  }

  public makeTrapSpike(chunk: ChunkBase, x: number, y: number): TrapSpikes {
    // console.log('trapSpike group size', this.trapSpikeGroup.getLength());
    let trapSpikes = this.trapSpikeGroup.get() as TrapSpikes;
    trapSpikes.x = x;
    trapSpikes.y = y;
    trapSpikes.init();
    trapSpikes.bindChunk(chunk);
    trapSpikes.reset();

    // console.log('trapSpike group size post', this.trapSpikeGroup.getLength());
    return trapSpikes;
  }

  public makeTrapCoconut(chunk: ChunkBase, x: number, y: number): TrapCoconuts {
    // console.log('trapCoconut group size', this.trapCoconutGroup.getLength());
    let trapCoconuts = this.trapCoconutGroup.get() as TrapCoconuts;
    trapCoconuts.x = x;
    trapCoconuts.y = y;
    trapCoconuts.init();
    trapCoconuts.bindChunk(chunk);
    trapCoconuts.reset();

    // console.log('trapCoconut group size post', this.trapCoconutGroup.getLength());
    return trapCoconuts;
  }

  public makeTrapTorch(chunk: ChunkBase, x: number, y: number): TrapAnimatedTorch {
    // console.log('trapTorch group size', this.trapTorchGroup.getLength());
    // let trapTorch = this.trapTorchGroup.get() as TrapTorch;
    let trapTorch = this.trapTorchGroup.get() as TrapAnimatedTorch;
    trapTorch.x = x;
    trapTorch.y = y;
    trapTorch.init();
    trapTorch.bindChunk(chunk);
    trapTorch.reset();

    // console.log('trapTorch group size post', this.trapTorchGroup.getLength());
    return trapTorch;
  }
}
